export enum CertificateCategory {
  LEASE = 'LEASE',
  CONTRACTUAL = 'CONTRACTUAL',
  AUTHORITIES = 'AUTHORITIES',
  LSG = 'LSG',
  LIABILITY = 'LIABILITY',
  PROPERTY = 'PROPERTY',
}
